/**
 * Zuordnung der Seiten des Backoffice zur Anleitung auf der Webseite (apps/website/src/help). Jede Seite verweist auf den Artikel, der erklärt, was man dort tut,
 * oder auf den Bereich, wenn es keinen passenden Artikel gibt. Gilt der erste passende Eintrag, stehen die genauen Pfade vor den allgemeinen.
 *
 * Ziel: `bereich/artikel` (zum Beispiel `kontakte/dubletten`) oder `bereich`. Beim Bau der Webseite prüft build.mjs, dass jedes Ziel existiert.
 */
import { HELP_TEXTS } from './help-texts.js';
export const HELP_TOPICS = [
    { pattern: /^\/$/, target: 'start/oberflaeche' },
    { pattern: /^\/konto\/(schichten|urlaub|antraege|mitarbeiter|dateien)/, target: 'team/urlaub-beantragen' },
    { pattern: /^\/konto/, target: 'start/mein-konto' },
    { pattern: /^\/anfragen\/neu/, target: 'anfragen/anfrage-erfassen' },
    { pattern: /^\/anfragen/, target: 'anfragen/anfragen-bearbeiten' },
    { pattern: /^\/einrichtung\/anfragetypen/, target: 'anfragen/anfragetyp-anlegen' },
    { pattern: /^\/kontakte\/dubletten/, target: 'kontakte/dubletten' },
    { pattern: /^\/kontakte\/[^/]+\/zusammenfuehren/, target: 'kontakte/dubletten' },
    { pattern: /^\/kontakte\/neu/, target: 'kontakte/kontakt-anlegen' },
    { pattern: /^\/kontakte/, target: 'kontakte/kontakte-suchen' },
    { pattern: /^\/einrichtung\/beziehungsarten/, target: 'kontakte/beziehungsarten' },
    { pattern: /^\/kalender\/termine\/neu/, target: 'termine/termin-anlegen' },
    { pattern: /^\/kalender\/termine/, target: 'termine/kalender-nutzen' },
    { pattern: /^\/kalender/, target: 'termine/aufgabe-anlegen' },
    { pattern: /^\/einrichtung\/terminarten/, target: 'termine/termin-anlegen' },
    { pattern: /^\/einrichtung\/(produktkategorien|einheiten|produkt-tags)/, target: 'verkauf/produkt-kategorien' },
    { pattern: /^\/produkte/, target: 'verkauf/produkt-anlegen' },
    { pattern: /^\/angebote\/(neu|[^/]+\/bearbeiten)/, target: 'verkauf/angebot-erstellen' },
    { pattern: /^\/angebote\/[^/]+$/, target: 'verkauf/angebot-versenden' },
    { pattern: /^\/angebote/, target: 'verkauf/angebot-erstellen' },
    { pattern: /^\/(auftraege|auftragscockpit|auftragsplanung)/, target: 'verkauf/auftrag-bearbeiten' },
    { pattern: /^\/rechnungen/, target: 'finanzen/rechnung-schreiben' },
    { pattern: /^\/eingangsrechnungen/, target: 'finanzen/eingangsrechnung-erfassen' },
    { pattern: /^\/kontenplan/, target: 'finanzen/kontenplan' },
    { pattern: /^\/finanzreport/, target: 'finanzen/finanzreport' },
    { pattern: /^\/einrichtung\/rechnungsnummern/, target: 'finanzen/rechnungsnummern' },
    { pattern: /^\/einrichtung\/finanzen/, target: 'finanzen/finanzeinstellungen' },
    { pattern: /^\/finanzierungen\/vorhaben\/[^/]+/, target: 'finanzen/finanzierungsmappe-bank' },
    { pattern: /^\/finanzierungen\/vorhaben/, target: 'finanzen/finanzierungsvorhaben-planen' },
    { pattern: /^\/finanzierungen\/kosten/, target: 'finanzen/kostenstruktur-personalkosten' },
    { pattern: /^\/finanzierungen/, target: 'finanzen/finanzierung-vertrag-anlegen' },
    { pattern: /^\/(debitoren|kreditoren|sachposten|finanzen)/, target: 'finanzen' },
    { pattern: /^\/vertraege/, target: 'vertraege/vertrag-erstellen' },
    { pattern: /^\/einrichtung\/loehne/, target: 'team/loehne-einrichten' },
    { pattern: /^\/loehne\/einrichtung/, target: 'team/loehne-einrichten' },
    { pattern: /^\/loehne\/arbeitszeiten/, target: 'team/arbeitszeiten-erfassen' },
    { pattern: /^\/loehne/, target: 'team/lohnlauf-erstellen' },
    { pattern: /^\/gutscheine/, target: 'verkauf/gutschein-ausstellen' },
    { pattern: /^\/rabattcodes/, target: 'verkauf/rabattcode-anlegen' },
    { pattern: /^\/einrichtung\/buchungsgruppen/, target: 'einrichtung/buchungsgruppen' },
    { pattern: /^\/mitarbeiter/, target: 'team/mitarbeiter-anlegen' },
    { pattern: /^\/schichtplanung/, target: 'team/schichtplan' },
    { pattern: /^\/(flotte|fahrtenbuch)/, target: 'betrieb/fahrzeug-anlegen' },
    { pattern: /^\/auftragsbuch/, target: 'betrieb/auftragsbuch' },
    { pattern: /^\/lager/, target: 'betrieb/lager-bestand' },
    { pattern: /^\/inventar/, target: 'betrieb/inventar' },
    { pattern: /^\/dokumente/, target: 'betrieb/dokument-hochladen' },
    { pattern: /^\/marketing\/abonnenten/, target: 'marketing/newsletter-abonnenten' },
    { pattern: /^\/marketing\/beitraege/, target: 'marketing/beitrag-veroeffentlichen' },
    { pattern: /^\/marketing/, target: 'marketing/kampagne-senden' },
    { pattern: /^\/chats/, target: 'marketing/live-chat' },
    { pattern: /^\/crm/, target: 'marketing/crm-uebersicht' },
    { pattern: /^\/auswertungen/, target: 'marketing/auswertungen' },
    { pattern: /^\/import-export/, target: 'einrichtung/import-export' },
    { pattern: /^\/einrichtung\/firmendaten/, target: 'einrichtung/firmendaten' },
    { pattern: /^\/einrichtung\/benutzer/, target: 'einrichtung/benutzer-einladen' },
    { pattern: /^\/einrichtung\/rollen/, target: 'einrichtung/rollen-rechte' },
    { pattern: /^\/einrichtung\/speicher/, target: 'einrichtung/speicher' },
    { pattern: /^\/einrichtung\/(api\/anfragen|webseite)/, target: 'einrichtung/webseite-formulare' },
    { pattern: /^\/einrichtung\/(api\/chat|chat)/, target: 'einrichtung/chat-fuer-webseite' },
    { pattern: /^\/einrichtung\/api\/newsletter/, target: 'einrichtung/newsletter-anmeldung-webseite' },
    { pattern: /^\/einrichtung\/fahrtrechnung/, target: 'einrichtung/rechnung-nach-der-fahrt' },
    { pattern: /^\/einrichtung\/nummernkennungen/, target: 'einrichtung/nummernkennungen' },
    { pattern: /^\/einrichtung\/daten-loeschen/, target: 'einrichtung/daten-loeschen' },
    { pattern: /^\/einrichtung\/api\/email/, target: 'einrichtung/email-einrichten' },
    { pattern: /^\/einrichtung\/api\/(stripe|paypal)/, target: 'einrichtung/zahlungsdienste-verbinden' },
    { pattern: /^\/einrichtung\/api\/(facebook|linkedin|tiktok)/, target: 'einrichtung/soziale-netzwerke-verbinden' },
    { pattern: /^\/einrichtung\/api/, target: 'einrichtung/email-einrichten' },
    { pattern: /^\/einrichtung\/(abrechnung|wirkia-konto)/, target: 'einrichtung/abonnement-rechnungen' },
    { pattern: /^\/einrichtung\/ueber/, target: 'einrichtung/paket-herunterstufen' },
    { pattern: /^\/(einrichtung|bestellen)/, target: 'einrichtung' },
];
/** Ziel der Anleitung zu einer Seite des Backoffice (`bereich/artikel` oder `bereich`), null ohne passenden Eintrag */
export function helpTarget(pathname) {
    return HELP_TOPICS.find((t) => t.pattern.test(pathname))?.target ?? null;
}
/** Pfad der passenden Anleitungsseite auf der Webseite, zum Beispiel `/anleitung/kontakte/dubletten/`. Ohne Treffer führt er zur Übersicht der Anleitung. */
export function helpPath(pathname) {
    const target = helpTarget(pathname);
    return target ? `/anleitung/${target}/` : '/anleitung/';
}
/** Kurzhilfe zu einer Seite für das „i“ im Menü: Überschrift, Zusammenfassung und die ersten Schritte des Artikels. Null, wenn es zur Seite keinen Artikel gibt. */
export function helpText(pathname) {
    const target = helpTarget(pathname);
    const text = target ? HELP_TEXTS[target] : undefined;
    return target && text ? { ...text, target, isArea: !target.includes('/') } : null;
}
//# sourceMappingURL=help.js.map